import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getAppConfigModules } from "../../ducks/appConfig";
import { api } from "../../evergis/api";

export const useAppModule = (moduleName: string) => {
  const modules = useSelector(getAppConfigModules);

  return useMemo(() => modules.find(({ name }) => name === moduleName), [modules, moduleName]);
};

export const usePrintModule = () => useAppModule("print");
export const useLayerListModule = () => useAppModule(api.isShared ? "shared-layer-list" : "layer-list");
export const useBasemapSelectModule = () => useAppModule("basemap-select");
export const useTableModule = () => useAppModule("table");
export const useCatalogModule = () => useAppModule("catalog");
export const useMapModule = () => useAppModule("map");
